export default async ({ output }) => {
    await output('You know who you are!')
}
